import { DiaryEntry } from "shared/types";
import { CustomFieldsType } from "shared/types/common";

export const allEqualCustomFields = (
  entries: DiaryEntry[],
  setState?: (value: CustomFieldsType[]) => void
) => {
  const map = new Map<string, CustomFieldsType>();

  for (const entry of entries) {
    const fields = entry.fields ?? [];
    for (const f of fields) {
      if (!f.id) continue;

      if (!map.has(f.id)) {
        map.set(f.id, f);
      }
    }
  }
  if (setState) {
    return setState(Array.from(map.values()));
  } else {
    return Array.from(map.values());
  }
};
